import React from 'react'
import { useT } from '@transifex/react'
type Props = {
  handleCancel: React.MouseEventHandler
  handleAdd: React.MouseEventHandler
  addBtnDisabled: boolean
}

export const DiscountPopoverActions = (props: Props) => {
  const { handleCancel, handleAdd, addBtnDisabled } = props
  const t = useT()
  return (
    <div className="vd-flex wr-discount-popover-actions vd-pb3 vd-pt3 vd-btn-group">
      <button
        className="vd-btn vd-btn--supplementary"
        type="button"
        onClick={handleCancel}
        data-testid="cancel_discount_popover"
      >
        {t('Cancel', { _context: 'Button' })}
      </button>
      <button
        className="vd-btn vd-btn--go pro-sl-discount-btn-add"
        type="button"
        disabled={addBtnDisabled}
        onClick={handleAdd}
      >
        {t('Add', { _context: 'Button' })}
      </button>
    </div>
  )
}
